module.exports = "/_next/static/images/OgHome-d7b3c7db5fe8313523e98ed96fa0d6d6.jpeg";